import { render } from "./MoveTop.vue?vue&type=template&id=fcc8c9b4"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MoveTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcc8c9b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcc8c9b4', __exports__)) {
    api.reload('fcc8c9b4', __exports__)
  }
  
  module.hot.accept("./MoveTop.vue?vue&type=template&id=fcc8c9b4", () => {
    api.rerender('fcc8c9b4', render)
  })

}


export default __exports__